import { sharedReducers } from '../shared';
import { combineReducers } from 'redux';
const rootReducer = combineReducers({
  sharedReducers,
});
export default rootReducer;
